function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.79 56.48L2 62.15a.06.06 0 01-.07-.07l5.63-19.82h0L46 3.85a7.11 7.11 0 0110 0L60.2 8a7.11 7.11 0 010 10.05L21.81 56.47zM54.55 23.73L40.31 9.5",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.89
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KPHRpdGxlPmVkaXQ8L3RpdGxlPgo8cGF0aCBkPSJNMjEuNzksNTYuNDgsMiw2Mi4xNWEuMDYuMDYsMCwwLDEtLjA3LS4wN0w3LjU2LDQyLjI2bDAsMEw0NiwzLjg1QTcuMTEsNy4xMSwwLDAsMSw1NiwzLjg1TDYwLjIsOGE3LjExLDcuMTEsMCwwLDEsMCwxMC4wNUwyMS44MSw1Ni40N1oiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44OSIvPjxsaW5lIHgxPSI1NC41NSIgeTE9IjIzLjczIiB4Mj0iNDAuMzEiIHkyPSI5LjUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44OSIvPgo8L3N2Zz4=";
export { SvgEdit as ReactComponent };